import { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  description?: string;
  /** Small uppercase overline rendered above the title (e.g. "DASHBOARDS"). */
  overline?: string;
  children?: ReactNode;
}

/**
 * Enterprise page header — compact, with an optional uppercase overline
 * that matches the reference (DASHBOARDS / INVENTORY / DETECTIONS).
 */
export function PageHeader({ title, description, overline, children }: PageHeaderProps) {
  return (
    <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between md:gap-4 min-w-0 max-w-full pb-2 border-b border-border/60">
      <div className="min-w-0 max-w-full flex items-baseline gap-3 flex-wrap">
        {overline && (
          <span className="text-[11px] font-semibold uppercase tracking-[0.16em] text-muted-foreground">
            {overline}
          </span>
        )}
        <h1 className="text-base md:text-lg font-semibold text-foreground tracking-tight truncate">
          {title}
        </h1>
        {description && (
          <p className="hidden md:block text-xs text-muted-foreground line-clamp-1 md:line-clamp-none">
            {description}
          </p>
        )}
      </div>
      {children && (
        <div
          className="
            flex flex-wrap items-stretch gap-2 min-w-0 max-w-full
            [&>*]:flex-1 [&>*]:min-w-0 [&>*]:basis-[calc(50%-0.25rem)]
            md:flex-nowrap md:[&>*]:flex-none md:[&>*]:basis-auto
            md:items-center
          "
        >
          {children}
        </div>
      )}
    </div>
  );
}
